<template lang="pug">
div
    dragger(@draggerDone="nextRoute()", v-if="startDragger")
    .scene.scene_1
        span.scene--space
        span.scene--space
        h3.scene--subtitle.scene--subtitle1 A performance of
        h2.scene--title
            span.layer(v-parallax="0.4", data-text="Digital") Digital
        h3.scene--subtitle.scene--subtitle2 Come to life
        button.scene--btn(v-audioHover="", @click="hideScene()")
            span Begin
        span.scene--space
</template>
<script>
import { TweenMax } from 'gsap'
import router from '@/router'
import variables from '@/variables.js'
import dragger from '@/components/dragger.vue'
export default {
    data() {
        return {
            startDragger: false
        }
    },
    mounted () {
        this.showScene()
        this.$store.commit('anatomy', true)
        setTimeout(() => {
            this.$emit('showBorderNav')
        }, 5000);
    },
    methods: {
        nextRoute() {
            this.$router.push({ name: 'Breathing' })
        },
        showScene() {
            let showTL = new TimelineLite()
            showTL
                .set('.scene_1', { opacity: 1, ease:Power4.easeOut }, '+=6')
                .from('.scene--title', 1, { opacity: 0, ease:Power2.easeOut })
                .from('.scene--subtitle1', 1, { opacity: 0, ease:Power2.easeOut })
                .from('.scene--subtitle2', 1, { opacity: 0, ease: Power2.easeOut, 
                    onComplete: function () {
                        document.querySelector('.scene--title span').classList.add('is-glitch');
                    }})
                .from('.scene--btn', 1, { width: 0, ease:Power2.easeOut }, '-=0.5')
                .from('.scene--btn span', 1, { y: 30, opacity: 0, ease: Power2.easeOut })
        },
        hideScene() {
            let self = this
            if( !self.$store.state.audio.file.currentTime > 0.1 ) {
                self.$store.state.audio.file.play()
            }
            let hideTL = new TimelineLite()
            document.querySelector('.background--video').play()
            if (variables.$paused && !variables.$pausedByClick) {
                console.log('are you here?')
                variables.$audioFile.play();
                variables.$audioFile.volume = 1;
            }
            hideTL
                .to('.scene--btn span', 1, { y: 30, opacity: 0, ease: Power2.easeIn })
                .to(['.scenes'], 1, { opacity: 0, ease: Power2.easeIn })
                .to('.scene--btn', 1, { width: 0, ease: Power2.easeIn })
                .set('.scene_1', { autoAlpha: 0, onComplete() {
                   self.startDragger = true
                } });
        }
    },
    components: {
        dragger
    }
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/home.vue